import { createDefaultWhatsNewCarouselState } from './defaults';
import type { WhatsNewCarouselPayloadBuilderState } from './types';

function snapshotWhatsNewCarouselState(state: WhatsNewCarouselPayloadBuilderState): string {
  return JSON.stringify({
    cards: state.cards.map((card) => ({
      isActive: card.isActive,
      enabledRegions: [...card.enabledRegions].sort(),
      startAt: card.startAt,
      endAt: card.endAt,
      imageId: card.imageId.trim(),
      imageOptionsFit: card.imageOptionsFit,
      overline: card.overline.trim(),
      title: card.title.trim(),
      description: card.description.trim(),
      ctaLabel: card.ctaLabel.trim(),
      ctaUrl: card.ctaUrl.trim(),
      optimizelyFeatureFlag: card.optimizelyFeatureFlag.trim(),
    })),
  });
}

/** Returns true when the user has entered or changed any What's New Carousel values from defaults. */
export function hasWhatsNewCarouselProgress(state: WhatsNewCarouselPayloadBuilderState, loadJson: string): boolean {
  if (loadJson.trim()) return true;
  return snapshotWhatsNewCarouselState(state) !== snapshotWhatsNewCarouselState(createDefaultWhatsNewCarouselState());
}
